import { SET_ADYEN_CONNECTED_ACCOUNT, SET_PAYMENT_STRIPE_ACCOUNT, SET_PAYPAL_NOTIFICATION, SET_STRIPE_NOTIFICATION, SET_TAP2PAY_NOTIFICATION_MODAL_SHOW } from '../../actionTypes/payment'

export const setPaymentStripeAccount = value => ({ type: SET_PAYMENT_STRIPE_ACCOUNT, value })

export const setPayPalNotification = value => ({ type: SET_PAYPAL_NOTIFICATION, value })

export const setStripeNotification = value => ({ type: SET_STRIPE_NOTIFICATION, value })

export const setTap2PayNotificationModalShow = value => ({ type: SET_TAP2PAY_NOTIFICATION_MODAL_SHOW, value })

export const setAdyenConnectedAccount = value => ({ type: SET_ADYEN_CONNECTED_ACCOUNT, value })
